const FullHeight = angular
    .module("FullHeight", [])
    .directive("fullHeight", ["$state", fullHeightDirective]);

function fullHeightDirective($state) {
    return {
        restrict: "A",
        link: function (scope, elem, attr, ctrl) {
            if ($state.current.data && $state.current.data.fullHeight) {
                angular.element(document.querySelector("#main-page")).addClass("is-full-height");
            } else {
                angular.element(document.querySelector("#main-page")).removeClass("is-full-height");
            }
        }
    };
}

export default FullHeight;
